var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractTypes from "./abstract";
var Ajax = /** @class */ (function (_super) {
    __extends(Ajax, _super);
    function Ajax() {
        var _this = _super.call(this) || this;
        _this.filter_type = 'select2_ajax';
        return _this;
    }
    Ajax.prototype.renderInput = function (rule) {
        if (rule.getFilter().filter_type !== this.filter_type) {
            return;
        }
        var rule_request = rule.getRule();
        var filter = rule.getFilter();
        var $select = rule.$el.find('.rule-value-container select');
        var $rule_container = $select.closest('.rule-container');
        if (rule_request && rule_request.formatted_value) {
            $select.append(jQuery('<option/>', {
                value: rule_request.value,
                text: rule_request.formatted_value,
                selected: true
            })).trigger('change');
            $rule_container.data('formatted_value', rule_request.formatted_value);
            AdminColumns.Search.validateForm();
        }
        $select.ac_select2({
            width: 200,
            theme: 'acs2',
            escapeMarkup: function (markup) {
                return jQuery("<div>" + markup + "</div>").text();
            },
            ajax: {
                method: 'post',
                url: ajaxurl,
                dataType: 'json',
                delay: 500,
                data: function (params) {
                    return {
                        action: 'acp_search_comparison_request',
                        method: 'get_options',
                        layout: AC.layout,
                        searchterm: params.term,
                        page: params.page ? params.page : 1,
                        column: filter.id,
                        list_screen: AC.list_screen,
                        item_id: 47,
                        _ajax_nonce: AC.ajax_nonce
                    };
                },
                processResults: function (response) {
                    return response.data;
                },
            }
        });
        $select.on('select2:select', function () {
            $rule_container.data('formatted_value', $select.find('option:selected').text());
            $rule_container.find('[data-confirm]').trigger('click').hide();
            jQuery(this).closest('[data-confirm]').trigger('click').hide();
        });
    };
    Ajax.prototype.transformFilter = function (filter) {
        if (filter.use_ajax && filter.use_pagination) {
            filter.filter_type = this.filter_type;
            filter.input = 'select';
        }
        return filter;
    };
    return Ajax;
}(AbstractTypes));
export default Ajax;
